import {
  type Site,
  EditorType,
  Namespace,
} from "@wix/ambassador-site-list-v2-site/types";
import { useEffect, useState } from "react";
import { useQuerySites } from "../../api/useQuerySites";
import { useAppContext } from "../Common/useAppContext";
import { PANORAMA_TRANSACTION_NAMES } from "../../../consts";
import { usePanorama } from "@wix/fe-essentials-standalone";

export const useSitesList = () => {
  const { transaction } = usePanorama();
  const { isLoggedIn } = useAppContext();
  const [allSites, setAllSites] = useState<Site[]>([]);

  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useQuerySites(isLoggedIn, {
      query: {
        cursorPaging: {
          limit: 8,
        },
        filter: {
          namespace: Namespace.HEADLESS,
          editorType: EditorType.PICASSO,
        },
      },
    });

  useEffect(() => {
    transaction(PANORAMA_TRANSACTION_NAMES.QUERY_SITES).start();
  }, [transaction]);

  useEffect(() => {
    if (data?.pages && data.pages.length > 0 && !isLoading) {
      setAllSites((prev) => [
        ...prev,
        ...(data.pages[data.pages.length - 1].sites || []),
      ]);
      transaction(PANORAMA_TRANSACTION_NAMES.QUERY_SITES).finish();
    }
  }, [data, isLoading]);

  const loadMore = () => {
    transaction(PANORAMA_TRANSACTION_NAMES.QUERY_SITES).start();
    fetchNextPage();
  };

  return {
    sites: allSites,
    isLoading,
    isFetchingNextPage,
    hasMore: hasNextPage,
    loadMore,
  };
};
